//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQBadge from "@/components/Generics/AQBadge/AQBadge.vue";
import trash from "@/assets/images/Buttons/trash.svg";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AddNewAccessPermissionModal from "./AddNewAccessPermissionModal.vue";

export default {
    name: "PermissionsModal",
    components: {
        AQModal,
        AQCard,
        AQButton,
        AQBadge,
        AQDialog,
        AddNewAccessPermissionModal
    },
    props: {
        entityDetails: { type: Object, default: () => {} }
    },
    data() {
        return {
            showPermissionsModal: false,
            permissionDetails: {},
            allPermissions: [],
            // eslint-disable-next-line global-require
            defaultImage: require("@/assets/images/appDefault.svg"),
            isEditPermission: false,
            hoverIndex: null,
            deleteIcon: trash,
            permissionListModified: false,
            showDialog: false,
            counter: 0,
            addAccessPermissionsModal: false,
            currentPermission: null
        };
    },
    computed: {
        save() {
            return {
                label: this.$t("admin.usersAndRoles.permissionsModal.saveBtn")
            };
        },
        getTitle() {
            return this.$t("globalDataModel.permissionsLabel", { entityName: this.entityDetails.name });
        }
    },
    watch: {
        entityDetails: {
            handler(val) {
                this.showPermissionsModal = !!(val && Object.keys(val).length);
            },
            immediate: true
        }
    },
    created() {
        this.getEntityPermissions(this.entityDetails.code).then(resPermissions => {
            for (let i = 0; i < resPermissions.data.length; i++) {
                this.allPermissions.push({
                    viewAudit: resPermissions.data[i].viewAud,
                    access: resPermissions.data[i].type,
                    value: resPermissions.data[i].applicationId,
                    label: resPermissions.data[i].name,
                    description: resPermissions.data[i].code,
                    imageUrl: resPermissions.data[i].imageUrl
                });
            }
            this.sortPermissions();
        });
    },
    methods: {
        ...mapActions("dataStore", ["getEntityPermissions", "saveEntityPermissions"]),
        actionsDlg($event) {
            if ($event === "save") {
                const formattedArray = [];
                for (let i = 0; i < this.allPermissions.length; i++) {
                    formattedArray.push({
                        type: this.allPermissions[i].access,
                        viewAud: this.allPermissions[i].viewAudit,
                        applicationId: this.allPermissions[i].value
                    });
                }
                this.saveEntityPermissions({ entityC: this.entityDetails.code, dataToSend: formattedArray }).then(() => {
                    this.$toast.showNotify({
                        message: this.$t("globalDataModel.notifyToast", { entityName: this.entityDetails.name }),
                        type: "success"
                    });
                });
                this.permissionListModified = false;
                this.$emit("input", false);
            }
            if ($event === "close") {
                if (this.permissionListModified) {
                    this.showDialog = true;
                } else {
                    this.permissionListModified = false;
                    this.$emit("input", false);
                }
            }
        },
        permissionData(event) {
            this.counter++;
            this.permissionDetails = event;
            const found = this.allPermissions.findIndex(elem => elem.value === this.permissionDetails.value);
            if (this.permissionDetails.permissionListModified) {
                this.permissionListModified = true;
            }
            if (found === -1) {
                this.allPermissions.push(this.permissionDetails);
                this.permissionListModified = true;
                this.sortPermissions();
            } else {
                this.allPermissions[found].access = this.permissionDetails.access;
                this.allPermissions[found].viewAudit = this.permissionDetails.viewAudit;
            }
        },
        addEditPermission(permission, isInEdit) {
            this.isEditPermission = isInEdit;
            this.currentPermission = permission;
            this.addAccessPermissionsModal = true;
        },
        getAppLogo(item) {
            return item || this.defaultImage;
        },
        deletePermission(item) {
            this.allPermissions.splice(this.allPermissions.indexOf(item), 1);
            this.permissionListModified = true;
        },
        sortPermissions() {
            this.allPermissions.sort((a, b) => {
                const classNameA = a.label.toLowerCase();
                const classNameB = b.label.toLowerCase();
                if (classNameA < classNameB) return -1;
                if (classNameA > classNameB) return 1;
                return 0;
            });
        },
        wrnAction(action) {
            if (action === "ok") {
                this.showDialog = false;
                this.showPermissionsModal = false;
                this.$emit("input", false);
            }
        },
        setBadgeText(permissionsCode) {
            let textToReturn = this.$t("globalDataModel.view");
            if (permissionsCode === "EDIT") {
                textToReturn = this.$t("globalDataModel.edit");
            }
            return textToReturn;
        }
    }
};
